import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Header from "../components/header/header"
import Hero from "../components/essentials-page/hero"
import UserExperience from "../components/essentials-page/01-userexperience"
import RosckStarSeo from "../components/essentials-page/02-rockstartseo"
import FastSecure from "../components/essentials-page/03-fastsecure"
import SocialCms from "../components/essentials-page/04-social-cms"
import StickyNav from "../components/sticky-nav"

const EssentialsPage = () => (
    <Layout>
      <SEO title="Website Essentials" />
      <Header />
      <Hero />
      <UserExperience />
      <RosckStarSeo />
      <FastSecure />
      <SocialCms />
      <StickyNav />
    </Layout>
  )
  
  export default EssentialsPage